// Texty stránky 404 (notFoundPage.js).
export default {
  code: '404',
  eyebrow: 'Stránka nenalezena',
  title: 'A safra! Tuhle stránku jsme nenašli.',
  perex:
    'Odkaz je nejspíš starý nebo obsahuje překlep. Produkt mohl také změnit název. ' +
    'Zkuste hledat podle názvu nářadí, nebo se rovnou proklikněte do hlavních kategorií.',
  placeholder: 'Napište, co hledáte',
  popularLabel: 'Nejhledanější:',
  where: 'Kam dál',
  linksTitle: 'Časté odkazy',
  best: 'Nejprodávanější',

  // rozcestník §„Kam dál" — klíč sedí na TILES v modulu
  tiles: {
    garden: { name: 'Zahrada', desc: 'Křovinořezy, sekačky, zavlažování a pily.' },
    build: { name: 'Stavba a dům', desc: 'Míchačky, centrály, čerpadla a topidla.' },
    workshop: { name: 'Dílna', desc: 'Aku nářadí, svařování a ruční nářadí.' },
    brands: { name: 'Značky', desc: 'Celý sortiment podle výrobce, A–Z.' },
    sale: { name: 'Slevoakce', desc: 'Zlevněné stroje a doprodeje skladem.' },
    service: { name: 'Servis nářadí', desc: 'Opravy, údržba a náhradní díly v Bílině.' },
  },

  // časté odkazy §„Pravý sloupec" — klíč sedí na LINKS v modulu
  links: {
    orderStatus: 'Stav objednávky',
    shipping: 'Doprava a platba',
    claim: 'Reklamační formulář',
    withdrawal: 'Odstoupení od smlouvy do 14 dnů',
    contact: 'Kontakt a prodejna',
  },

  // shoda nadpisu homepage skupiny (`.homepage-group-title`) z administrace
  bestHeadingRe: /nejprod|nejobl/i,

  advice: {
    eyebrow: 'Poradna Jipos',
    title: 'Řekněte nám, co jste hledali',
    text: 'Zavolejte nebo napište. Najdeme model, poradíme s alternativou a ověříme dostupnost.',
    textNoPhone: 'Napište nám. Najdeme model, poradíme s alternativou a ověříme dostupnost.',
    writeQuestion: 'Napsat dotaz',
  },
};
